var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"menuList"},[_vm._l((_vm.menuData),function(menu){return [_c('li',{key:menu.path,staticClass:"menuItem"},[_c('div',{staticClass:"el-dropdown cursor-pointer"},[_c('span',{staticClass:"el-dropdown-link",on:{"click":function($event){return _vm.goToLink(menu)}}},[_vm._v(_vm._s(menu.meta.title))])])])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }